"use strict";
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import PaymentAddressEditor from "../payment_address_editor";
import FactoringCompanyOfficePicker from "./factoring_company_office_picker";
import Account from "../../api/account";
import Address from "./address";
import get from "../data/get";
import Api from "../../api/api";
import WaitingSpinner from "../../components/waiting_spinner";
import DisablingButton from "../../components/disabling_button";
export default React.createClass({
  getInitialState: function() {
    return {
      paymentStrategy: this.props.carrier.payment_strategy,
      factoringCompanyOffice: null,
      isSavingFactor: false,
      isLoading: true
    };
  },
  componentWillMount: function() {
    if (this.state.paymentStrategy === "factor") {
      Api.FactoringAssignments.index(this.props.carrier.id).then((x) => {
        this.setState({
          isLoading: false,
          factoringCompanyOffice: get.factoringCompanyOffice(
            this.props.carrier
          )
        });
      });
    } else {
      this.setState({ isLoading: false });
    }
  },
  choose: function(paymentStrategy) {
    this.setState({
      paymentStrategy
    });
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.isLoading }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        name: "payment_strategy",
        checked: this.state.paymentStrategy === "direct",
        onChange: _.partial(this.choose, "direct")
      }
    ), "\xA0Direct to ", Account.carrierTerm()), /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        name: "payment_strategy",
        checked: this.state.paymentStrategy === "factor",
        onChange: _.partial(this.choose, "factor")
      }
    ), "\xA0Via Factor"), this.detail()));
  },
  carrierAddress: function() {
    if (this.props.carrier.payment_strategy == "direct") {
      return this.props.carrier.payment_address;
    }
  },
  detail: function() {
    if (this.state.paymentStrategy === "direct") {
      return /* @__PURE__ */ React.createElement(
        PaymentAddressEditor,
        {
          address: this.carrierAddress(),
          saveAddress: this.saveAddress,
          accountSettings: Account.currentSettings()
        }
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        FactoringCompanyOfficePicker,
        {
          factoringCompanyOffice: this.state.factoringCompanyOffice,
          onSelect: this.factoringCompanyOfficeSelected,
          onClear: this.factoringCompanyOfficeCleared
        }
      ), this.selectedAddress(), /* @__PURE__ */ React.createElement("div", null, "\xA0"), /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          className: "expand button--confirmation",
          onClick: this.saveFactor,
          disabledText: this.saveFactorDisabledText(),
          disabled: this.isSaveFactorDisabled()
        },
        "Save Address"
      ));
    }
  },
  selectedAddress: function() {
    if (this.state.factoringCompanyOffice) {
      var address = get.paymentAddress(this.state.factoringCompanyOffice);
      var line_2 = address.address_line_2 || "";
      if (!s.isBlank(line_2)) {
        line_2 = line_2 + " ";
      }
      line_2 = line_2 + "FBO " + this.props.carrier.name;
      var carrierAddress = _.extend(_.clone(address), {
        address_line_2: line_2
      });
      return /* @__PURE__ */ React.createElement(Address, { source: carrierAddress });
    }
  },
  saveFactorDisabledText: function() {
    return this.isInvalid() ? "Choose a Factoring Company Office" : "Saving...";
  },
  isSaveFactorDisabled: function() {
    return this.state.isSavingFactor || this.isInvalid();
  },
  isInvalid: function() {
    return _.isNull(this.state.factoringCompanyOffice);
  },
  factoringCompanyOfficeCleared: function() {
    this.setState({
      factoringCompanyOffice: null
    });
  },
  factoringCompanyOfficeSelected: function(factoringCompanyOffice) {
    this.setState({
      factoringCompanyOffice
    });
  },
  saveFactor: function() {
    if (this.state.factoringCompanyOffice) {
      this.setState({ isSavingFactor: true });
      this.props.onSave("factor", this.state.factoringCompanyOffice).then(
        (arg) => {
          this.setState({ isSavingFactor: false });
          return arg;
        },
        (arg) => {
          this.setState({ isSavingFactor: false });
          return arg;
        }
      );
    }
  },
  saveAddress: function(address) {
    return this.props.onSave("direct", address);
  }
});
